import React, { useState, useEffect } from "react";
import Paper from "@mui/material/Paper";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@emotion/react";
import Spinner from "../../../components/Spinner";
import { listHelpNSupport } from "../../../http/auth";
import HelpAndSupportTable from "./HelpAnsSupportTable";


export default function ManageHelpAndSupport() {
    const theme = useTheme();
    const smScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const [page, setPage] = useState(1);
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalCount, setTotalCount] = useState(0)
    const [nextId, setNextId] = useState("");

    const columns = [
        { id: "sr", label: "Sl. No.", minWidth: 40 },
        { id: "title", label: "Help And Support", minWidth: 140, sortable: true },
        { id: "action", label: "Action", minWidth: 60 },
    ];


    useEffect(() => {
        getHelpNSupport()
    }, [])

    const getHelpNSupport = async (pageArg) => {
        try {
            setLoading(true)
            const pg = pageArg ? pageArg : page
            const res = await listHelpNSupport(pg)
            const list = res?.data?.data?.support
            if (list) updateRows(list,pg)
            setTotalCount(res.data?.data?.totalSupport)
            setLoading(false)
        } catch (err) {
            setLoading(false)
            // dispatch(showToast({ color: "error", msg: "Something went wrong" }));
        }
    }


    function createData(sr, description, supportData, action) {
        return { sr, description, supportData, action };
    }

    const updateRows = (helpRequests, pageArg) => {
        const list = helpRequests.map((item, index) => {
            return createData(
                ((pageArg - 1) * 10 + 1) + index + 1,
                item.description || "",
                item,
                "-",
            );
        });
        const updatedList = nextId ? [...rows, ...list] : list;
        setRows(updatedList);
    };

    const onNextClick = async () => {
        setPage(page + 1);
        getHelpNSupport(page + 1)
    };

    const onPrevClick = async () => {
        setPage(page - 1);
        getHelpNSupport(page - 1)

    };

    return (
        <Paper
            sx={{
                width: "100%",
                height: "100%",
                overflow: "hidden",
                boxSizing: "border-box",
                boxShadow: "none",
            }}
        >
            <>
                {!loading ? (
                    <HelpAndSupportTable
                        smScreen={smScreen}
                        columns={columns}
                        rows={rows}
                        page={page}
                        nextId={nextId}
                        rowsPerPage={10}
                        setLoading={setLoading}
                        onPrevClick={onPrevClick}
                        onNextClick={onNextClick}
                        totalCount={totalCount}
                        getHelpNSupport={getHelpNSupport}
                    />
                ) : (
                    <Spinner />
                )}
            </>
        </Paper>
    );
}



